import { getDepartmentsByOrganization } from '@/lib/api/atendimento/departments'
import { Department } from '@/lib/api/common/interfaces/department.interface'
import { useAuth } from '@/store/hooks'
import { useEffect, useState } from 'react'

const PROVIDER_LABELS: Record<string, string> = {
    WHATSAPP_API: 'API oficial',
    WHATSAPP_WEB: 'WhatsApp Web',
}

/**
 * Setor que envia o WhatsApp de uma automação ou passo de follow-up.
 *
 * Vazio significa "setor da conversa do lead". Nunca cai no setor de
 * notificações: sem setor aqui e sem conversa com o contato, o envio não sai
 * (docs/sales-flows.md, seção 5).
 */
export default function SenderDepartmentSelect({
    value,
    onChange,
    size = 'md',
    emptyLabel = 'Setor da conversa do lead',
    emptyHint = 'Sai pelo setor em que o lead está conversando. Sem conversa, a mensagem não é enviada.',
}: {
    value?: number | null
    onChange: (departmentId: number | null) => void
    size?: 'xs' | 'md'
    /** Texto da opção vazia (nos fluxos, vazio herda o setor padrão do fluxo). */
    emptyLabel?: string
    emptyHint?: string | null
}) {
    const { user } = useAuth()
    const [departments, setDepartments] = useState<Department[]>([])

    useEffect(() => {
        if (!user?.organizationId) return
        getDepartmentsByOrganization(user.organizationId)
            .then(res => {
                if (res.success && Array.isArray(res.result)) {
                    setDepartments(res.result.filter(d => !!d.whatsappNumber))
                }
            })
            .catch(() => {})
    }, [user?.organizationId])

    const selected = departments.find(d => d.id === value)
    const selectClass = size === 'xs' ? 'select select-bordered select-xs w-full' : 'select select-bordered w-full'

    return (
        <div className="space-y-1">
            <select
                className={selectClass}
                value={value ?? ''}
                onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}
            >
                <option value="">{emptyLabel}</option>
                {departments.map(d => (
                    <option key={d.id} value={d.id}>
                        {d.name} ({PROVIDER_LABELS[d.whatsappProvider ?? 'WHATSAPP_API']})
                    </option>
                ))}
            </select>
            {!value && emptyHint && <p className="text-xs text-base-content/60 leading-snug">{emptyHint}</p>}
            {selected?.whatsappProvider === 'WHATSAPP_WEB' && (
                <p className="text-xs text-warning leading-snug">
                    WhatsApp Web: envios automáticos respeitam o limite por hora e por dia do setor (padrão 30 e 200), para evitar bloqueio do número.
                </p>
            )}
            {selected?.whatsappProvider === 'WHATSAPP_API' && (
                <p className="text-xs text-base-content/60 leading-snug">
                    API oficial: texto livre só dentro de 24h da última mensagem do contato neste setor.
                </p>
            )}
        </div>
    )
}
